export const toMetric = (height, weight, unit) => ({
  height: Number(height) * (unit === 'imperial' ? 2.54 : 1),
  weight: Number(weight) * (unit === 'imperial' ? 0.45359237 : 1)
});

export function validate(height, weight, unit) {
  if (height === '' || weight === '') {
    return 'Informe a altura e o peso para calcular.';
  }

  const metric = toMetric(height, weight, unit);

  if (!Number.isFinite(metric.height) || metric.height < 30 || metric.height > 250) {
    return 'A altura deve estar entre 30 e 250 cm (aproximadamente 11,8 a 98,4 pol).';
  }

  if (!Number.isFinite(metric.weight) || metric.weight < 1 || metric.weight > 400) {
    return 'O peso deve estar entre 1 e 400 kg (aproximadamente 2,2 a 881,8 lb).';
  }

  return '';
}

export const FORMULA_LABELS = [
  'Mosteller',
  'DuBois e DuBois',
  'Haycock',
  'Gehan e George',
  'Boyd',
  'Fujimoto',
  'Takahira',
  'Wang',
  'Livingston e Lee',
  'Schlich'
];

export function calculate(height, weight, sex = 'male') {
  const weightGrams = weight * 1000;
  const schlich = sex === 'female'
    ? 0.000975482 * weight ** 0.46 * height ** 1.08
    : 0.000579479 * weight ** 0.38 * height ** 1.24;

  return {
    Mosteller: Math.sqrt(height * weight / 3600),
    'DuBois e DuBois': 0.007184 * weight ** 0.425 * height ** 0.725,
    Haycock: 0.024265 * weight ** 0.5378 * height ** 0.3964,
    'Gehan e George': 0.0235 * weight ** 0.51456 * height ** 0.42246,
    Boyd: 0.0003207 * height ** 0.3 * weightGrams ** (0.7285 - 0.0188 * Math.log10(weightGrams)),
    Fujimoto: 0.008883 * weight ** 0.444 * height ** 0.663,
    Takahira: 0.007241 * weight ** 0.425 * height ** 0.725,
    Wang: 0.0061 * height + 0.0128 * weight - 0.1529,
    'Livingston e Lee': 0.1173 * weight ** 0.6466,
    Schlich: schlich
  };
}

export function calculateSchlichBySex(height, weight) {
  return {
    homens: 0.000579479 * weight ** 0.38 * height ** 1.24,
    mulheres: 0.000975482 * weight ** 0.46 * height ** 1.08
  };
}

export const formatArea = value => new Intl.NumberFormat('pt-BR', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
}).format(value);

export const formatPercent = value => new Intl.NumberFormat('pt-BR', {
  signDisplay: 'always',
  minimumFractionDigits: 1,
  maximumFractionDigits: 1
}).format(value);
